<template>
  <svg width="16" height="24" viewBox="0 0 16 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill="var(--theme-light)" d="M0 0h16v8H0z" />
    <path fill="var(--theme-main)" d="M0 16h16v8H0z" />
    <path fill="var(--theme-sharp)" d="M0 8h16v8H0z" />
  </svg>
</template>
